module.exports = __webpack_public_path__ + "img/rooster-animation-t.0ff50eae.gif";